import type { ReactElement, SVGProps } from 'react'

/*
 * Logotypy dostawców OAuth jako jednokreskowe SVG w stylu reszty ikon
 * (spec 06: ikony dostawców to outline 18×18 w kolorze tekstu, grubość 1,7).
 * Bez kolorowych logotypów marek — cała ikonografia produktu jest jednokreskowa.
 */

export interface ProviderIconProps extends SVGProps<SVGSVGElement> {
  size?: number
}

function outline(
  displayName: string,
  children: ReactElement,
): (props: ProviderIconProps) => ReactElement {
  function Icon({ size = 18, ...rest }: ProviderIconProps): ReactElement {
    return (
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        {...rest}
      >
        {children}
      </svg>
    )
  }
  Icon.displayName = displayName
  return Icon
}

export const GoogleIcon = outline(
  'GoogleIcon',
  <>
    <path d="M21 12.2c0-.7-.06-1.2-.2-1.8H12v3.3h5.1c-.1.9-.66 2.2-1.9 3.1l-.02.11 2.76 2.1.19.02C19.88 17.4 21 15 21 12.2z" />
    <path d="M12 21c2.5 0 4.6-.8 6.13-2.2l-2.92-2.24c-.78.54-1.83.92-3.21.92a5.56 5.56 0 0 1-5.27-3.8l-.11.01-2.87 2.19-.04.1A9 9 0 0 0 12 21z" />
    <path d="M6.73 13.68a5.5 5.5 0 0 1 0-3.36l-.01-.12L3.82 8l-.09.04a9 9 0 0 0 0 7.92z" />
    <path d="M12 6.58c1.75 0 2.93.74 3.6 1.36l2.63-2.53C16.6 3.99 14.5 3 12 3a9 9 0 0 0-8.27 5.04l2.99 2.28A5.58 5.58 0 0 1 12 6.58z" />
  </>,
)

export const AppleIcon = outline(
  'AppleIcon',
  <>
    <path d="M16.1 12.6c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.15-2.8.85-3.5.85-.7 0-1.85-.83-3.05-.8-1.55.02-3 .9-3.8 2.3-1.63 2.8-.42 6.95 1.16 9.23.78 1.11 1.7 2.36 2.9 2.32 1.17-.05 1.6-.75 3.02-.75 1.4 0 1.8.75 3.03.73 1.25-.02 2.04-1.13 2.8-2.25.88-1.29 1.24-2.54 1.26-2.6-.03-.02-2.42-.93-2.42-3.73z" />
    <path d="M13.9 5.6c.64-.78 1.07-1.86.95-2.94-.92.04-2.03.61-2.69 1.38-.59.69-1.11 1.79-.97 2.85 1.03.08 2.07-.52 2.71-1.29z" />
  </>,
)

export const GitHubIcon = outline(
  'GitHubIcon',
  <>
    <path d="M9 19.5c-4 1.2-4-2.1-5.6-2.6M15 21v-3.2c0-.9-.1-1.3-.6-1.8 2.4-.3 4.9-1.2 4.9-5.3a4.1 4.1 0 0 0-1.1-2.9 3.8 3.8 0 0 0-.1-2.9s-.9-.3-3 1.1a10.4 10.4 0 0 0-5.4 0C7.6 2.6 6.7 2.9 6.7 2.9a3.8 3.8 0 0 0-.1 2.9 4.1 4.1 0 0 0-1.1 2.9c0 4.1 2.5 5 4.9 5.3-.4.4-.6.9-.6 1.6V21" />
  </>,
)

export const GitLabIcon = outline(
  'GitLabIcon',
  <>
    <path d="M12 21 8.7 11h6.6z" />
    <path d="M12 21 3 11h5.7z" />
    <path d="m3 11 1.6-5.4c.13-.4.7-.4.83 0L8.7 11z" />
    <path d="M12 21 21 11h-5.7z" />
    <path d="m21 11-1.6-5.4a.44.44 0 0 0-.83 0L15.3 11z" />
  </>,
)

export const LockIcon = outline(
  'LockIcon',
  <>
    <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
  </>,
)

export const MailIcon = outline(
  'MailIcon',
  <>
    <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
    <path d="m3.5 7 8.5 6 8.5-6" />
  </>,
)

export const ShieldCheckIcon = outline(
  'ShieldCheckIcon',
  <>
    <path d="M12 3 19 5.5V11c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9V5.5z" />
    <path d="m9 12 2 2 4-4" />
  </>,
)
